import {
    getLoggerPositionsConfig,
} from 'app/utils/optionsLoggers'
import {
    LoggerType,
} from 'app/enums/label.enums'

const defaultConfigLoggers = ({
    loggerTypeOptions,
    loggerPositionsOptions,
    l,
}: {
    loggerTypeOptions: { value: LoggerType, label: string }[],
    loggerPositionsOptions: string[],
    l: (key: string) => string,
}) => {
    return [
        {
            title: l('LOGGER_TYPES'),
            name: 'loggerTypes',
            options: loggerTypeOptions,
        },
        getLoggerPositionsConfig({
            positions: loggerPositionsOptions,
            l,
        }),
    ]
}

export default defaultConfigLoggers
